/**
 * TODO: This service shouldn't be in shared or providedIn:root.
 *  - It probably doesn't need to exist and can be refactored to a profile service. Or at least be moved to profile and provided where it's needed.
 */

import { Injectable } from '@angular/core';
import { NormalizedRecommendation } from '@app/recommendations/recommendations.api';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from './modal.service';
import { LDFlagsService } from './ld-flags.service';
import { useApolloLayout } from '@degreed/apollo-angular';

/** Provides helpers that can be used with action options */
@Injectable({ providedIn: 'root' })
export class ActionOptionHelpersService {
  constructor(
    private translate: TranslateService,
    private modalService: ModalService,
    private ldFlagsService: LDFlagsService
  ) {}

  public deleteRecommendation(
    recommendation: NormalizedRecommendation,
    $event,
    onConfirm: () => any
  ) {
    if (!$event.type) {
      // ignore secondary events that aren't triggered by the user
      // (prevents duplicate modals)
      return;
    }

    if (recommendation.recommendationType === 'RequiredLearning') {
      const i18n = this.translate.instant([
        'Core_DismissDialogHeader',
        'RecommendationsOverviewCtrl_DismissDialogDescription',
        'Core_YesSure',
        'Core_Cancel',
        'Core_Remove',
        'Core_RemoveAssignment',
        'Core_RemoveAssignmentDescription',
      ]);
      const showLearnerHubAlertModal =
        useApolloLayout() &&
        this.ldFlagsService.useLearnerHub &&
        this.ldFlagsService.useNewLearnerAssignments;

      this.modalService
        .showAlert({
          title: showLearnerHubAlertModal
            ? i18n.Core_RemoveAssignment
            : i18n.Core_DismissDialogHeader,
          description: showLearnerHubAlertModal
            ? i18n.Core_RemoveAssignmentDescription
            : i18n.RecommendationsOverviewCtrl_DismissDialogDescription,
          cancelButtonText: i18n.Core_Cancel,
          confirmButtonText: showLearnerHubAlertModal
            ? i18n.Core_Remove
            : i18n.Core_YesSure,
          useApolloStyles: showLearnerHubAlertModal,
        })
        .subscribe(() => {
          onConfirm();
        });
    } else {
      onConfirm();
    }
  }
}
